@charset "UTF-8";

/* src/app/shared/contract/contract-item/contract-thema-nego/contract-thema-nego.component.scss */
.light-flex-card {
  background-color: #FFF;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  padding: 7px 10px;
  margin-bottom: 20px;
}
.sub-title {
  font: 700 16px FranceTV Brown;
  color: #001A33;
}
.header-item-filters {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;
  height: 30px;
  margin-bottom: 15px;
}
.container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 20px;
  margin: 0;
  border-radius: 5px;
  background-color: rgba(36, 70, 102, 0.05);
}
.item-all-content {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  font: 400 12px FranceTV Brown;
}
.guarantee-title {
  font-weight: 400 14px FranceTV Brown;
  color: #F03C64;
}
.buttons-container {
  display: flex;
  justify-content: flex-end;
}
.margin {
  margin: 5px;
}
.item {
  background-color: white;
  border-radius: 5px;
  padding: 15px;
  width: 100%;
  max-width: 100%;
  overflow: auto;
}
.item-content {
  display: flex;
  justify-content: space-between;
  font: 400 12px FranceTV Brown;
}
.item-header-and-conditions {
  display: flex;
  justify-content: flex-start;
}
.item-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
}
.item-header .targetId {
  width: 30px;
}
.item-header .targetLabel {
  width: 180px;
}
.item-header .packLabel {
  min-width: 100px;
}
.item-header .date-range {
  width: 150px;
}
.item-header .value {
  width: 70px;
}
.item-header .nctRate {
  width: 50px;
}
.item-channels-condition {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-width: 200px;
}
.item-channels-condition .channel-condition-value {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  min-width: 55px;
}
.item-conditions-value {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
  min-width: 200px;
}
.item-conditions-value .option-type-icon {
  height: 16px;
  width: 30px;
}
.item-conditions-value .option-condition-value {
  display: flex;
  flex-direction: column;
}
.item-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 25px;
}
.item-actions mat-icon {
  cursor: pointer;
  color: #616161;
  height: 20px;
}
@keyframes fadeOutLeft {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-100%);
  }
}
.mat-expansion-panel-header {
  height: 58px;
  padding: 0 15px 0 10px;
}
.mat-expansion-indicator {
  background-color: black;
}
.mat-expansion-panel-body {
  padding: 0 0 16px !important;
}
.channel-logo {
  margin-right: 8px;
  width: 20px;
  min-height: 19px;
  height: 20px;
}
/*# sourceMappingURL=contract-thema-nego.component.css.map */
